import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

export interface IMeal {
  [key: string]: {
    [key: string]: string[];
  };
}

const initialState: IMeal = {};

export const mealSlice = createSlice({
  name: "meal",
  initialState,
  reducers: {
    setMeal: (state, action: PayloadAction<any>) => {
      return {
        ...action.payload,
      };
    },
  },
});

export const { setMeal } = mealSlice.actions;
export default mealSlice.reducer;
